import { IconButton } from '@material-ui/core';
import cx from 'classnames';

import { IconDelete } from 'src/assets/icons/Delete';
import { IconEditPencil } from 'src/assets/icons/IconEditPencil';
// @ts-expect-error - CustomButton has no TypeScript declarations
import { CustomButton } from 'src/components/CustomButton';
import { CustomTooltip } from 'src/components/CustomTooltip';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { PersonaAvatar } from 'src/components/PersonaAvatar';
import { PersonaPainPoints } from 'src/components/PersonaPainPoints';
// @ts-expect-error - TruncatedTypography has no TypeScript declarations
import { TruncatedTypography } from 'src/components/TruncatedTypography';
import type { BrandVoiceRef } from 'src/data/brandVoice';
import { getAgeGroupLabel, getGenderLabel } from 'src/data/demographics';
import type { CustomerPersona } from 'src/data/persona';
import type { CallbackN } from 'src/lib/types';

import styles from './PersonaDetailsPanel.module.scss';

interface PersonaDetailsPanelProps {
  className?: string;
  persona: CustomerPersona;
  onEdit?: CallbackN<[CustomerPersona]>;
  onDelete?: CallbackN<[CustomerPersona]>;
  /** Saves a suggested audience into the first of `brandVoices`. */
  onSave?: CallbackN<[BrandVoiceRef, CustomerPersona]>;
  brandVoices?: BrandVoiceRef[];
  isSaving?: boolean;
  painPointsCount?: number;
}

export const PersonaDetailsPanel = ({
  className,
  persona,
  onEdit,
  onDelete,
  onSave,
  brandVoices = [],
  isSaving = false,
  painPointsCount,
}: PersonaDetailsPanelProps) => {
  const { name, avatarType, minAge, maxAge, gender, painPoints, isSuggested } = persona;

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.header}>
        <PersonaAvatar
          className={styles.avatar}
          avatarType={avatarType}
        />
        <div>
          <TruncatedTypography
            className={styles.name}
            variant={TYPOGRAPHY_VARIANT.semiBold14}
          >
            {name}
          </TruncatedTypography>
          <CustomTypography
            className={styles.description}
            variant={TYPOGRAPHY_VARIANT.regular12}
          >
            {minAge} - {maxAge != null && getAgeGroupLabel(maxAge)} <span>•</span>{' '}
            {gender && getGenderLabel(gender)}
          </CustomTypography>
        </div>

        <div className={styles.actions}>
          <CustomTooltip title="Edit">
            <IconButton
              className={styles.iconButton}
              onClick={() => onEdit?.(persona)}
            >
              <IconEditPencil />
            </IconButton>
          </CustomTooltip>

          <CustomTooltip title="Delete">
            <IconButton
              className={styles.iconButton}
              onClick={() => onDelete?.(persona)}
            >
              <IconDelete />
            </IconButton>
          </CustomTooltip>
        </div>
      </div>
      <PersonaPainPoints
        className={styles.painPoints}
        painPoints={painPoints}
        maxCount={painPointsCount}
      />
      {isSuggested && (
        <div className={styles.saveButtonContainer}>
          <CustomTooltip title="Save to your target audiences">
            <CustomButton
              variant="contained"
              color="silver"
              loading={isSaving}
              onClick={() => onSave?.(brandVoices[0], persona)}
            >
              Save
            </CustomButton>
          </CustomTooltip>
        </div>
      )}
    </div>
  );
};
